import { createReducer, on, union } from '@ngrx/store';
import { IOrder } from '../model/order.model';
import { orderActions } from './order.actions';
import { OrderState } from './order.state';

export const initialOrderState: OrderState = {
  order: {} as IOrder
};
 
export const orderReducer = createReducer(
    initialOrderState,

    on( orderActions.getOrderDataSuccess, (state , { order }) => ({ 
      ...state, 
      order: order 
    })),
);  